import React, { useState } from "react";
import { Send, Mail, Phone, MapPin } from "lucide-react";
import { toast } from "sonner";
import { submitContact } from "../lib/api";

export const ContactPage = () => {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [submitting, setSubmitting] = useState(false);

  const update = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) {
      toast.error("Συμπληρώστε όλα τα πεδία.");
      return;
    }
    setSubmitting(true);
    try {
      await submitContact(form);
      toast.success("Το μήνυμά σας εστάλη! Θα σας απαντήσουμε σύντομα.");
      setForm({ name: "", email: "", message: "" });
    } catch (err) {
      toast.error("Αποτυχία αποστολής. Δοκιμάστε ξανά.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <main className="min-h-screen" data-testid="contact-page">
      <section className="py-16 md:py-24 border-b border-white/5">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="text-xs tracking-[0.3em] uppercase text-zinc-500 font-bold mb-3">Επικοινωνία</div>
          <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-black tracking-tighter">
            Ας <span className="text-[#B026FF] neon-glow-pink">φωτίσουμε</span> την ιδέα σου
          </h1>
          <p className="text-zinc-400 mt-4 max-w-xl">
            Custom neon, ειδικές παραγγελίες ή απλά μία ερώτηση; Γράψε μας.
          </p>
        </div>
      </section>

      <section className="py-14">
        <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-[1fr_2fr] gap-12">
          <div className="flex flex-col gap-6">
            <InfoRow icon={Mail} title="Email" value="gkledbusiness@gmail.com" href="mailto:gkledbusiness@gmail.com" />
            <InfoRow icon={Phone} title="Τηλέφωνο" value="+30 699 979 4496" href="tel:+306999794496" />
            <InfoRow icon={MapPin} title="Περιοχή" value="Θεσσαλονίκη, Ελλάδα" />
          </div>

          <form
            onSubmit={handleSubmit}
            className="bg-[#050505] border border-white/5 rounded-2xl p-6 md:p-8 flex flex-col gap-5"
            data-testid="contact-form"
          >
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <label className="flex flex-col gap-2">
                <span className="text-xs text-zinc-400 font-medium">Όνομα *</span>
                <input
                  value={form.name}
                  onChange={update("name")}
                  required
                  className="neon-input"
                  data-testid="contact-name"
                />
              </label>
              <label className="flex flex-col gap-2">
                <span className="text-xs text-zinc-400 font-medium">Email *</span>
                <input
                  type="email"
                  value={form.email}
                  onChange={update("email")}
                  required
                  className="neon-input"
                  data-testid="contact-email"
                />
              </label>
            </div>
            <label className="flex flex-col gap-2">
              <span className="text-xs text-zinc-400 font-medium">Μήνυμα *</span>
              <textarea
                rows={6}
                value={form.message}
                onChange={update("message")}
                required
                className="neon-input resize-none"
                data-testid="contact-message"
              />
            </label>

            <button
              type="submit"
              disabled={submitting}
              className="inline-flex items-center justify-center gap-2 bg-[#B026FF] text-black px-6 py-4 rounded-lg font-bold hover:neon-box-glow-pink transition-all disabled:opacity-40"
              data-testid="contact-submit"
            >
              {submitting ? "Αποστολή..." : (<><Send size={16} /> Αποστολή μηνύματος</>)}
            </button>
          </form>
        </div>
      </section>

      <style>{`
        .neon-input {
          width: 100%;
          background: #0A0A0A;
          border: 1px solid rgba(255,255,255,0.08);
          color: white;
          padding: 0.75rem 1rem;
          border-radius: 0.5rem;
          font-size: 0.9rem;
          outline: none;
          transition: border-color 0.2s, box-shadow 0.2s;
        }
        .neon-input:focus {
          border-color: #B026FF;
          box-shadow: 0 0 0 1px #B026FF;
        }
      `}</style>
    </main>
  );
};

const InfoRow = ({ icon: Icon, title, value, href }) => {
  const content = (
    <>
      <div className="p-3 rounded-lg bg-[#B026FF]/10 text-[#B026FF]">
        <Icon size={18} />
      </div>
      <div>
        <div className="text-xs text-zinc-500 uppercase tracking-wider mb-1">{title}</div>
        <div className="font-medium">{value}</div>
      </div>
    </>
  );
  if (href) {
    return (
      <a
        href={href}
        className="flex items-start gap-4 p-5 rounded-2xl border border-white/5 bg-[#050505] hover:border-[#B026FF]/40 transition-colors"
      >
        {content}
      </a>
    );
  }
  return (
    <div className="flex items-start gap-4 p-5 rounded-2xl border border-white/5 bg-[#050505]">
      {content}
    </div>
  );
};

export default ContactPage;
